import { callApi } from '@/api/apibase'

export const logInCriipto = function(jwtToken, loginType, cvr, testMode) {
    let body = 'grant_type=' + loginType + '&jwttoken=' + encodeURIComponent(jwtToken) + (cvr ? '&cvr=' + encodeURIComponent(cvr) : '')

    if(testMode) {
        body = 'grant_type=testCriipto&test_mode=' + process.env.VUE_APP_CRIIPTO_TEST_MODE_SECRET + '&jwttoken=' + encodeURIComponent(jwtToken) + (cvr ? '&cvr=' + encodeURIComponent(cvr) : '')
    }

    let headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': '*'
    }
    return callApi('POST', '/Token', null, headers, body)
}

